import { render, staticRenderFns } from "./uf_list_products_nacional_projects.vue?vue&type=template&id=089816c6&scoped=true"
import script from "./uf_list_products_nacional_projects.vue?vue&type=script&lang=js"
export * from "./uf_list_products_nacional_projects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089816c6",
  null
  
)

export default component.exports